var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6267 2H9.63672V5C9.63672 7.20914 7.84586 9 5.63672 9H2.63672V20C2.63672 21.1 3.53672 22 4.63672 22H16.6367C17.7367 22 18.6367 21.1 18.6367 20L18.6303 9.68449C18.1164 8.8375 17.3596 8.16675 16.456 7.77114L15.8367 7.5L16.456 7.22886C17.358 6.83395 18.1137 6.16487 18.6275 5.32L18.6267 4C18.6267 2.89 17.7267 2 16.6267 2ZM11.7424 16.9375L11.3034 18L10.8644 16.9375C10.0612 14.9934 8.5574 13.4454 6.66889 12.6186L5.63672 12.1667L6.66889 11.7148C8.5574 10.8879 10.0612 9.33992 10.8644 7.39587L11.3034 6.33333L11.7424 7.39587C12.5456 9.33992 14.0494 10.8879 15.9379 11.7148L16.9701 12.1667L15.9379 12.6186C14.0494 13.4454 12.5456 14.9934 11.7424 16.9375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63672 2V5C7.63672 6.10457 6.74129 7 5.63672 7H2.63672L7.63672 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3304 5.45537L20.1367 5L19.943 5.45537C19.5887 6.28854 18.9253 6.95197 18.0921 7.30633L17.6367 7.5L18.0921 7.69367C18.9253 8.04803 19.5887 8.71146 19.943 9.54463L20.1367 10L20.3304 9.54463C20.6847 8.71146 21.3482 8.04803 22.1813 7.69367L22.6367 7.5L22.1813 7.30633C21.3482 6.95197 20.6847 6.28854 20.3304 5.45537Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.5d0499a1df1c85f051c0448e7f3f689f.svg";
export { ForwardRef as ReactComponent };